/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import Router from 'next/router';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';
import Icon from '../../Icon';

import data from './ecosystem-data';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: auto;
  padding-bottom: 107px;
  background: #0f1217;
  cursor:pointer;
`;

const Content = styled.div`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
  text-align: center;
  font-family: ${({ theme }) => theme.fontIBMLight};
  vertical-align: middle;
`;

const Title = styled.div`
  text-align: center;
  font-size: 54px;
  font-family: ${({ theme }) => theme.fontIBMLight};
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  margin: 80px 0 50px 0;
  > a {
    display: block;
    line-height: 32px;
    font-size: 18px;
    font-weight: 500;
    font-family: ${({ theme }) => theme.fontIBMMedium};
    color: #f0b90b;
    margin-top: 20px;
  }
`;

const RadiusBox = styled.div`
  position: relative;
  width: 700px;
  height: 700px;
  margin: 0 auto;
  transform: rotateX(180deg);
`;

const Item = styled.div`
  position: absolute;
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border-radius: 100%;
  transform: rotateX(-180deg);
  color: #fff;
  font-size: 60px;
  > .iconfont {
    margin: 0;
    font-size: 45px;
    display: block;
    width: 80px;
    height: 80px;
    line-height: 80px;
    border-radius: 100%;
    border: 1px solid transparent;
    &:hover {
      color: #f0b90b;
      border: 1px solid #f0b90b;
    }
  }
  &.active {
    > .iconfont {
      color: #f0b90b;
      border: 1px solid #f0b90b;
    }
  }
`;
const Dot = styled.div`
  position: absolute;
  width: 400px;
  height: 400px;
  left: 50%;
  top: 50%;
  margin: -200px 0 0 -200px;
  transform: rotateX(-180deg);
  > .dot-table {
    display: table;
    width: 100%;
    height: 100%;
    > .dot-cell {
      display: table-cell;
      vertical-align: middle;
      width: 100%;
      text-align: center;
      font-family: ${({ theme }) => theme.fontIBMLight};
      > .iconfont {
        font-size: 90px;
        color: #f0b90b;
        margin: 0;
        line-height: 100%;
      }
      > h3 {
        font-size: 20px;
        color: #fff !important;
        margin: 50px 0 25px 0;
        padding: 0;
        font-family: ${({ theme }) => theme.fontIBMMedium};
      }
      > p {
        font-size: 18px;
        color: rgba(255, 255, 255, 0.6);
        margin: 0 0 30px 0;
        line-height: 24px;
        font-family: ${({ theme }) => theme.fontIBMRegular};
      }
      > a {
        font-size: 18px;
        color: #f0b90b;
        text-decoration: none;
        font-weight: 500;
        font-family: ${({ theme }) => theme.fontIBMMedium};
      }
    }
  }
`;

let SHOW_ID = 1;

type Props = {
  i18n: Object,
  locale: string,
};

type States = {
  showId: number,
  timer: any,
};

export default
@withI18n
class Ecosystem extends React.Component<Props, States> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
  };

  state = {
    showId: 1,
    timer: null,
  };

  componentDidMount() {
    this._slider();
  }

  _slider = () => {
    const { timer } = this.state;
    if (timer) this._clearInterval();
    const _timer = setInterval(() => {
      if (SHOW_ID === 1) {
        SHOW_ID += 1;
        if (SHOW_ID > 9) {
          SHOW_ID = 1;
        }
      } else {
        SHOW_ID += 1;
        if (SHOW_ID > 9) {
          SHOW_ID = 1;
        }
      }
      this.setState({ showId: SHOW_ID });
    }, 2500);
    this.setState({
      timer: _timer,
    });
  };

  _clearInterval = (id: number) => {
    const { timer } = this.state;
    if (id) {
      SHOW_ID = id;
      this.setState({ showId: SHOW_ID });
    }
    if (timer) clearInterval(timer);
  };

  _handleClick = (e:MouseEvent) => {
    e.stopPropagation();
    Router.push(`/${this.props.locale}/ecosystem`)
  }

  _jump = (e:MouseEvent, url: string) => {
    e.stopPropagation();
    window.open(url, { target: '_blank' });
  }

  render() {
    const { i18n, locale } = this.props;
    const ItemData = data;
    return (
      <WrapperBox direction="column" onClick={this._handleClick}>
        <Content>
          <Title>
            {getLabel('exchange-ecosystem-ecosystem', i18n)}
            <a id="ecosystem-a-titleLearnMore">
              {getLabel('exchange-common-learnMore', i18n)} {'>>'}
            </a>
          </Title>
          <RadiusBox>
            {ItemData.map(item => (
              <Dot key={item.id} style={{ display: SHOW_ID === item.id ? 'block' : 'none' }} >
                {item.detail && (
                  <div className="dot-table">
                    <div className="dot-cell">
                      <Icon type={item.detail.icon} />
                      <h3>{getLabel(item.detail.title, i18n)}</h3>
                      <p>{getLabel(item.detail.description, i18n)}</p>
                      <a id={item.detail.ecosystemDataId} href="javascript:;" onClick={(e) => this._jump(e, item.detail.url)} target="_blank" rel="noopener noreferrer nofollow">
                        {getLabel('exchange-common-viewAll', i18n)}
                      </a>
                    </div>
                  </div>
                )}
              </Dot>
            ))}

            {ItemData.map(item => (
              <React.Fragment key={item.id}>
                <Item
                  style={{ left: item.left, top: item.top }}
                  className={SHOW_ID === item.id ? 'active' : null}
                  onMouseOver={() => this._clearInterval(item.id)}
                  onFocus={() => this._clearInterval(item.id)}
                  onMouseLeave={this._slider}
                  onClick={(e) => {e.stopPropagation();}}
                >
                  <Icon type={item.icon} />
                </Item>
                {item.dot.map(dot => (
                  <Item key={dot.id} style={{ left: dot.left, top: dot.top }}>
                    {dot.text}
                  </Item>
                ))}
              </React.Fragment>
            ))}
          </RadiusBox>
        </Content>
      </WrapperBox>
    );
  }
}
